import { render, staticRenderFns } from "./roomAdmin.vue?vue&type=template&id=208ce658&"
import script from "./roomAdmin.vue?vue&type=script&lang=js&"
export * from "./roomAdmin.vue?vue&type=script&lang=js&"
import style0 from "./roomAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports